<template>
  <div ui-view="" class="app-body" id="view">
      <div ui-view="" class="app-body" id="view">
        <!-- ############ PAGE START-->
        <page-header title="사이트 관리" description="VMS 사이트 내부 보안서약서, 반입자산 종류, 체크리스트를 관리합니다.">
        </page-header>
        <div class="page-body ph-30">
          <tos-list/>
          <asset-list/>
          <check-list/>
        </div>
      </div>
  </div>
</template>
<script>
  import PageHeader from '@/layout/PageHeader.vue'
  import dropdown from "@/components/Dropdown.vue"
  import TosList from './TosList.vue'
  import AssetList from './AssetList.vue'
  import CheckList from './CheckList.vue'

  export default {
    components: {
      PageHeader,
      dropdown,
      TosList,
      AssetList,
      CheckList,
    },

    data() {
      return {
        tosList: null,
        assetList: null,
        checkList: null,
        isEnable: [
          {display: '비활성', value: 0},
          {display: '활성', value: 1}
        ],
        isRequired: [
          {display: '선택', value: 0},
          {display: '필수', value: 1}
        ],
        checkType: null
      }
    },
    created(){

    },
    mounted(){
      this.init();
    },
    computed: {
      // isEdit(){
      //   return (item) =>{
      //     return item.isEdit;
      //   }
      // },
    },
    methods: {
      init(){
        this.getTosList();
        this.getAssetList();
        this.getCheckList();
        this.getCheckType();
      },
      getTosList(){
        this.$http.get('/api/tos')
          .then((result) => {
            this.tosList = result.data;
          }).catch((e) =>{
          })
      },
      getAssetList(){
//        this.$http.defaults.headers.common["token"] = 'token';
        this.$http.get('/api/public/asset')
          .then((result) => {
            this.assetList = result.data;
          }).catch((e) =>{
          })
      },
      getCheckList(){
        this.$http.get('/api/public/checkList')
          .then((result) => {
            this.checkList = result.data;
          }).catch((e) =>{
        })
      },
      getCheckType(){
        this.$http.get('/api/public/checkType')
          .then((result) => {
            this.checkType = result.data;
            this.checkType.forEach(x => {
              x.display = x.checkTypeStr;
              x.value = x.checkTypeCode;
            })
          }).catch((e) =>{
        })
      },


      addTos(){
        let obj = {
          tosTitle: '',
          tosAgreeText: '',
          tosContents: '',
          isRequired: 1,
          isEnable: 1
        };

        this.tosList.push(obj);
      }
    }
  }
</script>
<style>

</style>
